import {NgModule} from '@angular/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSortModule} from '@angular/material/sort';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatListModule} from '@angular/material/list';
import {MatRadioModule} from '@angular/material/radio';
import {MatTabsModule} from '@angular/material/tabs';
import {MatMenuModule} from '@angular/material/menu';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatCheckboxModule} from '@angular/material/checkbox';

@NgModule({
  imports: [MatButtonModule, MatToolbarModule, MatSidenavModule, MatFormFieldModule, MatChipsModule, MatInputModule, MatProgressSpinnerModule,
    MatIconModule, MatCardModule, MatListModule, MatRadioModule, MatDatepickerModule, MatSelectModule, MatCheckboxModule, MatDialogModule,
    MatTableModule, MatSortModule, MatDividerModule, MatTabsModule, MatMenuModule, MatExpansionModule, MatTooltipModule, MatPaginatorModule],
  exports: [MatButtonModule, MatToolbarModule, MatSidenavModule, MatFormFieldModule, MatChipsModule, MatInputModule, MatProgressSpinnerModule,
    MatIconModule, MatCardModule, MatListModule, MatRadioModule, MatDatepickerModule, MatSelectModule, MatCheckboxModule, MatDialogModule,
    MatTableModule, MatSortModule, MatDividerModule, MatTabsModule, MatMenuModule, MatExpansionModule, MatTooltipModule, MatPaginatorModule],
})
export class MaterialModule {
}
